"use client";
import SectionPage from "@/components/common/section-page";

import { useNavigate } from "react-router-dom";
import {OnlyImageBgCard, PaveScaleCard} from "@/components/common/pave-scale-card";
import EspaceProTitleCard from "@/components/common/espace-pro-title-card";

export default function Home() {
  const navigate = useNavigate();

  return (
          <div className={"flex flex-col gap-6 pb-6 mb-8"}>

            <EspaceProTitleCard title={"L’Office et Vous"} description={"Découvrez les missions et la vision de cette structure dotée de ressources importantes au cœur de l’écosystème touristique ivoirien."} />

          {/* Nature & Biodiversité */}
          <SectionPage sectionType="lg">
              <p className={"text-normal text-justify"}>


                  L’information est au cœur de l’écosystème numérique touristique. Elle nourrit les stratégies des destinations, alimente les démarches et enrichit les outils de connaissances et d’aide à la décision.
<br/>
<br/>
                  Mettre la data en mouvement !
                  <br/>
                  <br/>
                  Avec comme enjeux stratégiques d’enrichir la connaissance et développer les outils d’aide à la décision et d’élargir le champ d’analyse économique du tourisme.

              </p>
          </SectionPage>

              <SectionPage sectionType="lg">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6 mb-6">
                      <PaveScaleCard title={"Engagement / Charte"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/office-et-vous/engagement-charte" titleClassName={"font-playfair-display italic font-bold"} />
                      <OnlyImageBgCard imageSrc={"/images/espace-pro/office-et-vous/1.jpg"} className={"h-[400px]"} />
                      <PaveScaleCard title={"Centre de Ressources"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/office-et-vous/centre-de-ressources" titleClassName={"font-playfair-display italic font-bold"} />
                      <PaveScaleCard title={"Les Rendez-vous Pros"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/office-et-vous/rendez-vous-pros" titleClassName={"font-playfair-display italic font-bold"} />
                      <OnlyImageBgCard imageSrc={"/images/espace-pro/office-et-vous/2.jpg"} className={"h-[400px]"} />
                      <PaveScaleCard title={"Qualifier mon Offre"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/office-et-vous/qualifier-mon-offre" titleClassName={"font-playfair-display italic font-bold"} />
                  </div>
              </SectionPage>

        </div>
  );
}
